<template>
    <div class="col-12">
        <div class="row mt-2 mb-1" v-if="!vacationdata.external && vacationdata.yearlyCarriedOver == 0">
            <div class="col-9">
                {{ $trans.get("__JSON__.Days available") }}
                <span v-if="vacationdata.afterContractDays"> {{ $trans.get("__JSON__.until contract end / exit") }}
                </span>
            </div>
            <div v-if="vacationdata.afterContractDays > 0" class="col-3 text-end">
                {{ vacationdata.daysLeft + vacationdata.afterContractReservedDays }}
            </div>
            <div v-if="vacationdata.afterContractDays == 0 || !vacationdata.afterContractDays" class="col-3 text-end">
                {{ vacationdata.daysLeft }}
            </div>
            <div class="col-9">
                {{ $trans.get("__JSON__.Days reservable") }}
                <span v-if="vacationdata.afterContractDays > 0"> 
                    {{ $trans.get("__JSON__.after contract end") }}
                </span>
            </div>
            <div class="col-3 text-end">
                <span class="blue font-weight-bold" v-if="vacationdata.afterContractDays > 0">
                    {{ vacationdata.afterContractDays - vacationdata.afterContractReservedDays }}
                </span>
            </div>
            <div class="col-9 pe-0" v-if="employee && vacationdata.afterContractDays > 0"> 
                {{ $trans.get("__JSON__.Additional days after contract renewal reservable after") }}: 
            </div>
            <div class="col-3 ps-0 text-end">
                <span class="font-weight-bold ">
                    {{ transformDate(employee.most_recent_contract.end_at).toISODate() }} 
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import {luxonParseDate} from "../transformDate";  

export default {
    name: "MyVacationYearAdditionalInfos",
    props: {
        vacationdata: {
            type: Object,
            required: true
        },
        employee: {
            type: Object,
            default: null
        }
    },
    methods: {
        transformDate(date) {
            return luxonParseDate(date);
        }
    }
}
</script>